/**
 * DevExtreme (esm/core/templates/child_default_template.js)
 * Version: 23.2.3
 * Build date: Tue Nov 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    TemplateBase
} from "./template_base";
export class ChildDefaultTemplate extends TemplateBase {
    constructor(name) {
        super();
        this.name = name
    }
}
